import "reflect-metadata";
import {inject, injectable} from "inversify";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";
import {InternalChatMessageEntity} from "@dropDesk/domain/entities/internal_chat/messages/internal_chat_message_entity";

@injectable()
export class GetMessageByIdUseCase {
    private _repository: InternalChatRepository;

    constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
        this._repository = repository;
    }

    public call(id: string): Promise<InternalChatMessageEntity> {
        return this._repository.getMessageById(id);
    }
}
